import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { defineStore } from 'pinia';

export const useToastStore = defineStore('toast', () => {
  // Toast.vue에서 사용
  const { t } = useI18n();
  const messages = ref([]); // 여러 토스트 메시지 관리
  const RETENTION_MILLIS = 5000; // 지속 시간 5000 5초

  const showHintBox = ref('');
  const hintBoxHtml = ref(null);
  const isDisabledHintBox = ref(false);
  let hintBoxIntervalId;
  let toastIntervalId;
  const enableHintBox = ref(true);

  const addToast = (newMessage, type = 'info', givenId) => {
    if (
      messages.value &&
      messages.value[messages.value.length - 1]?.message === newMessage
    ) {
      //중복메시지 연속 노출 방지
      return null;
    }

    if (givenId) {
      closeToast(givenId);
      setTimeout(() => {
        doAddToast(newMessage, type, givenId);
      }, 300);
      return givenId;
    }

    const id = String(Date.now());
    doAddToast(newMessage, type, id);
    return id;
  };

  function doToastInterval() {
    if (!toastIntervalId) {
      toastIntervalId = setInterval(() => {
        messages.value = messages.value.filter(
          (message) => Date.now() - message.seq < RETENTION_MILLIS
        );
        clearToastInterval();
      }, 500);
    }
  }

  const doAddToast = (newMessage, type, id) => {
    messages.value.push({
      id: id,
      message: newMessage,
      type,
      isVisible: true,
      seq: Date.now(),
    });
    doToastInterval();
  };

  const info = (newMessage, id = null) => {
    return addToast(newMessage, 'info', id);
  };

  const warn = (newMessage, id = null) => {
    return addToast(newMessage, 'warn', id);
  };

  const error = (newMessage, id = null) => {
    return addToast(newMessage, 'error', id);
  };

  const closeToast = (id) => {
    messages.value = messages.value.filter((toast) => toast.id !== id);
    clearToastInterval();
  };

  const clearToastInterval = () => {
    if (!messages.value || messages.value.length === 0) {
      clearInterval(toastIntervalId);
      toastIntervalId = null;
      if (messages.value && messages.value.length !== 0) {
        doToastInterval();
      }
    }
  };

  const isShowing = (id) => {
    return messages.value.some((message) => message.id === id);
  };

  const hintBox = (hostDom, keyMessage) => {
    if (!enableHintBox.value) return;
    hintBoxHtml.value = t(keyMessage);
    showHintBox.value = hostDom;
  };

  const useHintBox = (enable) => {
    enableHintBox.value = enable;
  };

  return {
    messages, //전체 토스트
    showHintBox,
    isDisabledHintBox,
    hintBoxHtml,
    useHintBox,
    info,
    warn,
    error,
    closeToast,
    hintBox,
    isShowing,
  };
});
